import { useContext } from "react";
import { ConfigContext } from "../context/ConfigContext";
export const useLogger = () => {
    const logger = useContext(ConfigContext).logger;
    if (!logger)
        throw new Error("logger not initialized");
    return logger;
};
